import { render, staticRenderFns } from "./OrderQuery.vue?vue&type=template&id=f484fdd8&scoped=true"
import script from "./OrderQuery.vue?vue&type=script&lang=js"
export * from "./OrderQuery.vue?vue&type=script&lang=js"
import style0 from "./OrderQuery.vue?vue&type=style&index=0&id=f484fdd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f484fdd8",
  null
  
)

export default component.exports